module.exports = __webpack_public_path__ + "img/iot.0b035a44.jpg";